// PeptideVault v6.5 — Dashboard + user dashboard + categories + changelog

// ══════════════════════════════════════════════════════
// RENDER: DASHBOARD TAB
// ══════════════════════════════════════════════════════
function renderPeptideLibraryTab() {
  const lib = [...(S.peptideLibrary||[])].sort((a,b) => a.scientificName.localeCompare(b.scientificName))
  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px">
      <h2 style="font-size:20px;font-weight:700">Peptide Library</h2>
      <div class="spacer"></div>
      <button class="btn btn-ghost btn-sm" onclick="dedupeLibrary()" title="Merge duplicate entries">Remove Duplicates</button>
      <button class="btn btn-secondary btn-sm" onclick="syncLibraryFromInventory()">🔄 Sync &amp; Fill Names</button>
      <button class="btn btn-primary btn-sm" onclick="openModal('addLibraryEntry')">${ICONS.plus} Add Entry</button>
    </div>
    <div style="font-size:13px;color:var(--text3);margin-bottom:16px">
      Scientific names paired with custom vial/display names. Used throughout inventory, protocols, and category cards.
    </div>
    <div class="card" style="padding:0;overflow:hidden">
      <div style="display:grid;grid-template-columns:2fr 2fr 2fr auto;gap:0;padding:8px 14px;background:var(--bg3);font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;letter-spacing:.4px;border-bottom:1px solid var(--border2)">
        <span>Scientific Name</span><span>Custom Vial Name</span><span>Categories</span><span></span>
      </div>
      ${lib.length === 0 ? '<div class="empty-state" style="padding:32px"><div class="empty-icon">🔬</div><p>No library entries</p></div>' :
        lib.map((e,i) => `
        <div style="display:grid;grid-template-columns:2fr 2fr 2fr auto;gap:8px;align-items:center;padding:10px 14px;${i>0?'border-top:1px solid var(--border2)':''}${!e.active?';opacity:.5':''}">
          <div>
            <div style="font-size:13px;font-weight:600">${esc(e.scientificName)}</div>
            ${e.isBlend ? '<span style="font-size:10px;background:var(--purpleL);color:var(--purpleT);border-radius:4px;padding:1px 5px">Blend</span>' : ''}
          </div>
          <div style="font-size:13px;color:var(--text2)">${esc(e.customVialName||'—')}</div>
          <div style="font-size:11px;color:var(--text3)">${(e.categories||[]).join(', ')||'—'}</div>
          <div class="row" style="gap:4px">
            <button class="btn btn-ghost btn-xs" onclick="openModal('editLibraryEntry',{libId:'${e.id}'})">${ICONS.edit}</button>
            <button class="btn btn-ghost btn-xs" onclick="toggleLibraryActive('${e.id}')" title="${e.active?'Deactivate':'Activate'}">${e.active?'✓':'○'}</button>
          </div>
        </div>`).join('')}
    </div>
  </div>`
}

// ══════════════════════════════════════════════════════
// RENDER: CATEGORY CARDS TAB
// ══════════════════════════════════════════════════════
function renderCategoryCardsTab() {
  const catPrefix = label => (label||'').split('/')[0].trim().toLowerCase()
  const allCats = getAllCategories()  // already sorted A→Z
  const mainPrefixes = allCats.map(c => catPrefix(c.label))

  // Active (non-archived) inventory peptides
  const activePeps = (S.peptides||[]).filter(p => !p.archived)
  // Peptides with no category, or a category matching no card
  const orphanPeps = activePeps.filter(p => {
    const cats = p.categories || []
    if (!cats.length) return true
    return !cats.some(c => mainPrefixes.includes(catPrefix(c)))
  })

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:20px;flex-wrap:wrap;gap:8px">
      <div>
        <h2 style="font-size:20px;font-weight:700">Peptide Categories</h2>
        <div style="font-size:13px;color:var(--text3);margin-top:4px">Group your peptides by category. Built-in categories plus any you create.</div>
      </div>
      <div class="spacer"></div>
      <button class="btn btn-primary btn-sm" onclick="openModal('addCategory')">${ICONS.plus} New Category</button>
    </div>
    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:14px">
      ${allCats.map(cat => {
        const prefix = catPrefix(cat.label)
        const items = activePeps.filter(p => (p.categories||[]).some(c => catPrefix(c) === prefix))
        const customRecord = (S.customCategories||[]).find(c => c.label === cat.label)
        const canDelete = !!customRecord && !customRecord.builtinId
        return `
        <div class="card" style="overflow:hidden;border-top:3px solid ${cat.color}">
          <div class="card-body" style="gap:8px">
            <div class="row" style="align-items:flex-start">
              <div style="flex:1">
                <div style="font-size:14px;font-weight:700">${esc(cat.label)}</div>
                <div style="font-size:11px;color:var(--text3);margin-top:3px;line-height:1.4">${esc(cat.desc||'')}</div>
              </div>
              <div style="display:flex;align-items:center;gap:4px;flex-shrink:0">
                <span style="background:${cat.color}22;color:${cat.color};font-size:11px;font-weight:700;padding:2px 8px;border-radius:10px">${items.length}</span>
                <button class="btn-icon" style="width:22px;height:22px" title="Edit category" onclick="openCategoryEdit('${esc(cat.label).replace(/'/g,"\\'")}')">${ICONS.edit}</button>
                ${canDelete ? `<button class="btn-icon" style="width:22px;height:22px" title="Delete category" onclick="deleteCustomCategory('${esc(cat.label).replace(/'/g,"\\'")}')">${ICONS.trash}</button>` : ''}
              </div>
            </div>
            ${items.length > 0 ? `
            <div style="border-top:1px solid var(--border2);padding-top:8px;display:flex;flex-direction:column;gap:4px">
              ${items.slice(0,5).map(p => `
                <div style="font-size:12px">
                  <span style="font-weight:600">${esc(p.name)}</span>
                  ${p.customVialName ? `<span style="color:var(--text3)"> — ${esc(p.customVialName)}</span>` : ''}
                </div>`).join('')}
              ${items.length > 5 ? `<div style="font-size:11px;color:var(--text4)">+${items.length-5} more</div>` : ''}
            </div>` : `
            <div style="font-size:12px;color:var(--text4);padding-top:4px">No peptides in this category yet</div>`}
            <button class="btn btn-secondary btn-sm" style="margin-top:8px;width:100%" onclick="openCategoryAssign('${esc(cat.label).replace(/'/g,"\\'")}')">${ICONS.plus} Manage Peptides</button>
          </div>
        </div>`
      }).join('')}

      ${orphanPeps.length ? `
        <div class="card" style="overflow:hidden;border-top:3px solid var(--text4)">
          <div class="card-body" style="gap:8px">
            <div class="row" style="align-items:flex-start">
              <div style="flex:1">
                <div style="font-size:14px;font-weight:700">Unassigned</div>
                <div style="font-size:11px;color:var(--text3);margin-top:3px;line-height:1.4">Peptides with no category. Use "Manage Peptides" on a category to assign them.</div>
              </div>
              <span style="background:#99999922;color:#777;font-size:11px;font-weight:700;padding:2px 8px;border-radius:10px;flex-shrink:0">${orphanPeps.length}</span>
            </div>
            <div style="border-top:1px solid var(--border2);padding-top:8px;display:flex;flex-direction:column;gap:4px">
              ${orphanPeps.slice(0,8).map(p => `
                <div style="font-size:12px;display:flex;justify-content:space-between;align-items:center">
                  <span><span style="font-weight:600">${esc(p.name)}</span>${p.customVialName ? `<span style="color:var(--text3)"> — ${esc(p.customVialName)}</span>` : ''}</span>
                  <button class="btn btn-ghost btn-xs" onclick="openModal('editPeptide',{pid:'${p.id}'})">Edit</button>
                </div>`).join('')}
              ${orphanPeps.length > 8 ? `<div style="font-size:11px;color:var(--text4)">+${orphanPeps.length-8} more</div>` : ''}
            </div>
          </div>
        </div>` : ''}
    </div>
  </div>`
}

// ══════════════════════════════════════════════════════
// RENDER: CHANGE LOG TAB
// ══════════════════════════════════════════════════════
function renderChangeLogTab() {
  const log = S.changeLog || []
  const types = ['all',...new Set(log.map(c=>c.entityType))].filter(Boolean)

  const filterType = S.changeLogFilter || 'all'
  const filtered = filterType === 'all' ? log : log.filter(c => c.entityType === filterType)

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px">
      <h2 style="font-size:20px;font-weight:700">Change Log</h2>
      <div class="spacer"></div>
      ${log.length ? `<button class="btn btn-ghost btn-sm" onclick="appConfirm('Clear all change log entries?',()=>{S.changeLog=[];save();render()})">Clear Log</button>` : ''}
    </div>
    ${types.length > 1 ? `<div class="filter-bar" style="margin-bottom:12px">
      ${types.map(t => `<button class="filter-btn ${filterType===t?'active':''}" onclick="S.changeLogFilter='${t}';render()">${t==='all'?'All':t}</button>`).join('')}
    </div>` : ''}
    ${filtered.length === 0 ? `
    <div class="card"><div class="empty-state" style="padding:48px">
      <div class="empty-icon">📋</div>
      <p>No changes recorded yet</p>
      <span>Changes to supplements, peptides, and other records will appear here</span>
    </div></div>` : `
    <div class="card" style="padding:0;overflow:hidden">
      ${filtered.slice(0,100).map((c,i) => `
      <div style="padding:10px 14px;${i>0?'border-top:1px solid var(--border2)':''}">
        <div class="row" style="gap:8px;align-items:flex-start">
          <span style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--text4);background:var(--bg3);padding:2px 6px;border-radius:4px;flex-shrink:0">${esc(c.entityType||'system')}</span>
          <div style="flex:1;font-size:13px">${esc(c.description)}</div>
          <div style="font-size:11px;color:var(--text4);flex-shrink:0">${new Date(c.createdAt).toLocaleString()}</div>
        </div>
      </div>`).join('')}
      ${filtered.length > 100 ? `<div style="padding:10px;text-align:center;font-size:12px;color:var(--text4)">Showing 100 of ${filtered.length} entries</div>` : ''}
    </div>`}
  </div>`
}


// ══════════════════════════════════════════════════════
// RENDER: PER-USER DASHBOARD
// ══════════════════════════════════════════════════════

function renderDashboardTab() {
  const activeUsers = (S.users||[]).filter(u => u.active)
  const hasMultipleUsers = activeUsers.length > 1
  const currentUser = S._dashboardUser || (activeUsers[0]?.id || '')
  const currentUserName = activeUsers.find(u => u.id === currentUser)?.name || 'All'
  const today = localDateKey()
  const now7 = localDateOffset(7)
  const now30 = localDateOffset(30)
  const now90 = localDateOffset(90)

  // ── Planned Schedule from Protocols + Cycles ──
  const plannedToday = []
  const plannedWeek = []

  // P0-2 FIX: Derive from unified engine (P1-5: protocols as source of truth)
  var allPlannedEvents = typeof resolveAllProtocols === 'function' ? resolveAllProtocols(S.protocols || []) : []
  for (var ei = 0; ei < allPlannedEvents.length; ei++) {
    var ev = allPlannedEvents[ei]
    if (ev.date === today) plannedToday.push({ name: ev.peptideName || ev.protocolName, dosage: (ev.doseAmount||'') + ' ' + (ev.doseUnit||''), cycle: 'protocol' })
    if (ev.date >= today && ev.date <= now7) plannedWeek.push({ name: ev.peptideName || ev.protocolName, date: ev.date, dosage: (ev.doseAmount||'') + ' ' + (ev.doseUnit||'') })
  }

  const activeCycles = (S.cycleTimelines||[]).filter(ct => {
    if (!ct.compounds) return false
    return ct.compounds.some(comp => {
      const entries = comp.entries||[]
      return entries.some(e => e.date >= today)
    })
  })
  for (const ct of activeCycles) {
    for (const comp of (ct.compounds||[])) {
      for (const entry of (comp.entries||[])) {
        if (entry.date === today) plannedToday.push({ name: comp.name, dosage: entry.dosage, cycle: ct.importedAt })
        if (entry.date >= today && entry.date <= now7) plannedWeek.push({ name: comp.name, date: entry.date, dosage: entry.dosage })
      }
    }
  }

  // ── Protocols (from S.protocols or derived from cycles) ──
  var activeProtocols = (S.protocols||[]).filter(function(p) { return p.status === 'active' })

  // ── Upcoming ordered vials / combined pen loads ──
  const upcomingVialPlans = activeProtocols.map(function(protocol) {
    const peptide = (S.peptides||[]).find(function(p){return p.id===protocol.peptideId||p.name===protocol.peptideName})
    const rows = (S.inventoryReservations||[]).filter(function(r){return r.protocolId===protocol.id&&r.workflowStatus!=='completed'}).sort(function(a,b){return (Number(a.sequence)||9999)-(Number(b.sequence)||9999)})
    const groups = []
    rows.forEach(function(r) {
      const key = r.loadGroup ? 'load-'+r.loadGroup : 'vial-'+(r.sequence||r.id)
      let group = groups.find(function(g){return g.key===key})
      if (!group) { group={key:key,items:[],penId:r.penId||''}; groups.push(group) }
      const sku = ((peptide&&peptide.skus)||[]).find(function(s){return s.id===r.skuId})
      const strength = Number(sku&&skuMgPerVial(sku))||0
      const qty = Math.max(1,Number(r.qty!=null?r.qty:r.quantity)||1)
      for (let i=0;i<qty;i++) group.items.push({sku:sku,strength:strength})
    })
    groups.forEach(function(group){group.totalMg=group.items.reduce(function(sum,item){return sum+item.strength},0);group.pen=(S.peptidePens||[]).find(function(p){return p.id===group.penId})})
    return {protocol:protocol,peptide:peptide,groups:groups}
  }).filter(function(plan){return plan.groups.length})

  // ── Upcoming Plan Changes ──
  const planChanges = []
  for (const ct of (S.cycleTimelines||[])) {
    for (const comp of (ct.compounds||[])) {
      const entries = (comp.entries||[]).sort((a,b) => a.date.localeCompare(b.date))
      const future = entries.filter(e => e.date > today)
      if (future.length > 0) {
        const last = entries[entries.length - 1]
        if (last.date <= now30) planChanges.push({ type: 'ending', name: comp.name, date: last.date })
      }
      // Detect dose changes
      for (let i = 1; i < future.length; i++) {
        if (future[i].dosage !== future[i-1].dosage) {
          planChanges.push({ type: 'dose_change', name: comp.name, date: future[i].date, from: future[i-1].dosage, to: future[i].dosage })
          break
        }
      }
    }
  }

  // ── Inventory Readiness (from Protocol Engine forecast) ──
  var forecastResults = typeof forecastInventory === 'function' ? forecastInventory(S.protocols||[], S.peptides||[], S.inventoryReservations||[], 90) : []
  const readiness = forecastResults.map(function(fr) {
    return { name: fr.peptideName, onHand: fr.onHand, needed: fr.vialsNeeded || fr.totalDoses, shortfall: fr.shortfall || 0, totalMg: fr.totalMg, canCalcMg: fr.canCalcMg }
  }).filter(function(r) { return r.needed > 0 })

  // ── Expiring Before Plan Use ──
  const expirationConflicts = []
  for (const p of (S.peptides||[])) {
    for (const sku of (p.skus||[])) {
      if (!sku.expiryDate || skuQty(sku) <= 0) continue
      // Check if planned usage extends past expiry
      const plannedAfterExpiry = activeCycles.some(ct =>
        (ct.compounds||[]).some(comp =>
          ((comp.linkedPeptideIds||[]).includes(p.id) || comp.name === p.name) &&
          (comp.entries||[]).some(e => e.date > sku.expiryDate)
        )
      )
      if (plannedAfterExpiry || sku.expiryDate <= now90) {
        const expired = sku.expiryDate <= today
        const urgent = sku.expiryDate <= now30
        expirationConflicts.push({ name: p.name, type: 'Peptide', expiry: sku.expiryDate, expired, urgent, plannedConflict: plannedAfterExpiry, vendor: sku.vendor||'' })
      }
    }
  }
  for (const s of (S.supplements||[])) {
    if (s.expiryDate && s.expiryDate <= now90 && (s.quantityOnHand||0) > 0) {
      expirationConflicts.push({ name: s.name, type: 'Supplement', expiry: s.expiryDate, expired: s.expiryDate <= today, urgent: s.expiryDate <= now30 })
    }
  }
  for (const sup of (S.injectionSupplies||[])) {
    for (const sk of (sup.skus||[])) {
      if (sk.expiryDate && sk.expiryDate <= now90 && injSupplyQty(sk) > 0)
        expirationConflicts.push({ name: sup.name, type: 'Supply', expiry: sk.expiryDate, expired: sk.expiryDate <= today, urgent: sk.expiryDate <= now30 })
    }
  }
  expirationConflicts.sort((a,b) => a.expiry.localeCompare(b.expiry))

  // ── Low Stock ──
  const lowItems = []
  for (const p of (S.peptides||[])) {
    const thresh = +(p.lowStockThreshold||0)
    if (thresh > 0 && peptideQty(p) <= thresh) lowItems.push({ name: p.name, type: 'Peptide', qty: peptideQty(p), thresh })
  }
  for (const s of (S.supplements||[])) {
    if (typeof suppNeedsRestockAlert === 'function' && !suppNeedsRestockAlert(s)) continue
    const days = +(s.lowStockDays||0)
    const supply = s.dailyServing > 0 ? Math.floor((s.quantityOnHand||0) / s.dailyServing) : 999
    if (days > 0 && supply <= days) lowItems.push({ name: s.name, type: 'Supplement', qty: s.quantityOnHand||0, thresh: days, unit: 'days' })
  }
  for (const sup of (S.injectionSupplies||[])) {
    const thresh = +(sup.lowStockThreshold||0)
    if (thresh > 0 && injSupplyTotalQty(sup) <= thresh) lowItems.push({ name: sup.name, type: 'Supply', qty: injSupplyTotalQty(sup), thresh })
  }

  // ── Supplements Reference ──
  const userSupps = (S.supplements||[]).filter(s => {
    if (typeof suppLifecycleStatus === 'function' && !['active','phase_out','protocol'].includes(suppLifecycleStatus(s))) return false
    if (typeof suppLifecycleStatus !== 'function' && (s.status||'active') === 'inactive') return false
    if (!currentUser) return true
    const by = s.takenBy || 'both'
    return by === 'both' || by === currentUser || by === currentUserName.toLowerCase()
  })
  const amSupps = userSupps.filter(s => s.timeOfDay === 'am' || s.timeOfDay === 'both')
  const noonSupps = userSupps.filter(s => s.timeOfDay === 'noon')
  const pmSupps = userSupps.filter(s => s.timeOfDay === 'pm' || s.timeOfDay === 'both')

  // ── Quick Stats (actionable — onclick navigates) ──
  const totalPeptides = S.peptides.length
  const totalSupplements = userSupps.length
  const totalSupplyUnits = (S.injectionSupplies||[]).reduce((a,s) => a + injSupplyTotalQty(s), 0)

  // ── Data Quality ──
  const dqIssues = []
  for (const p of (S.peptides||[])) {
    for (const sku of (p.skus||[])) {
      if (!sku.expiryDate && skuQty(sku) > 0) dqIssues.push({ msg: p.name + ' — SKU missing expiration date', tab: 'peptides' })
      if (!sku.vendor) dqIssues.push({ msg: p.name + ' — SKU missing vendor', tab: 'peptides' })
    }
    if ((p.categories||[]).length === 0) dqIssues.push({ msg: p.name + ' — no categories assigned', tab: 'peptides' })
  }
  for (const s of (S.supplements||[])) {
    if (!s.category) dqIssues.push({ msg: s.name + ' — no category', tab: 'supplements' })
    if (!(s.dailyServing > 0)) dqIssues.push({ msg: s.name + ' — no serving size set', tab: 'supplements' })
  }
  for (const v of (S.vendors||[])) {
    if (!v.website && !v.email) dqIssues.push({ msg: v.name + ' — no contact info', tab: 'vendors' })
  }
  const dismissed = S.dataQualityDismissed || []
  const activeDQ = dqIssues.filter(d => !dismissed.includes(d.msg))

  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:20px;flex-wrap:wrap;gap:10px">
      <h2 style="font-size:20px;font-weight:700;margin:0">Dashboard</h2>
      <div class="spacer"></div>
      ${hasMultipleUsers ? `
      <div style="display:flex;gap:4px">
        ${activeUsers.map(u => `<button class="btn btn-sm ${currentUser===u.id?'btn-primary':'btn-secondary'}" onclick="S._dashboardUser='${u.id}';render()">${esc(u.name)}</button>`).join('')}
      </div>` : ''}
    </div>

    <!-- Quick Stats — clickable to navigate -->
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;margin-bottom:20px">
      <div class="card" style="padding:16px;text-align:center;cursor:pointer" onclick="setTab('peptides')">
        <div style="font-size:28px;font-weight:700;color:var(--blue)">${totalPeptides}</div>
        <div style="font-size:12px;color:var(--text3)">Peptides</div>
      </div>
      <div class="card" style="padding:16px;text-align:center;cursor:pointer" onclick="setTab('supplements')">
        <div style="font-size:28px;font-weight:700;color:var(--green)">${totalSupplements}</div>
        <div style="font-size:12px;color:var(--text3)">Supplements</div>
      </div>
      <div class="card" style="padding:16px;text-align:center;cursor:pointer" onclick="setTab('injsupplies')">
        <div style="font-size:28px;font-weight:700;color:var(--amber)">${totalSupplyUnits}</div>
        <div style="font-size:12px;color:var(--text3)">Supply Units</div>
      </div>
      <div class="card" style="padding:16px;text-align:center;cursor:pointer" onclick="setTab('${lowItems.length ? 'peptides' : 'dashboard'}')">
        <div style="font-size:28px;font-weight:700;color:${lowItems.length?'var(--red)':'var(--green)'}">${lowItems.length}</div>
        <div style="font-size:12px;color:var(--text3)">Low Stock</div>
      </div>
    </div>

    <!-- Upcoming ordered vials / pen loads -->
    ${upcomingVialPlans.length ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('allocation')"><div class="card-title">🧪 Upcoming Vials & Pen Loads</div><span class="badge badge-blue">${upcomingVialPlans.reduce((sum,p)=>sum+p.groups.length,0)} planned</span></div>
      <div style="padding:0 16px 14px;display:flex;flex-direction:column;gap:12px">
        ${upcomingVialPlans.map(plan => `
          <div style="border-top:1px solid var(--border);padding-top:10px">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:7px"><strong style="font-size:13px">${esc(plan.protocol.name||plan.protocol.peptideName||'Protocol')}</strong><span style="font-size:11px;color:var(--text4)">${esc(plan.peptide&&plan.peptide.name||'')}</span><div class="spacer"></div><button class="btn btn-ghost btn-xs" onclick="openProtocolVialPlan('${plan.protocol.id}')">Edit plan</button></div>
            <div style="display:flex;gap:8px;overflow-x:auto;padding-bottom:2px">
              ${plan.groups.slice(0,6).map((group,index) => `
                <div style="min-width:145px;padding:9px 10px;border:1px solid ${index===0?'var(--accent)':'var(--border2)'};border-radius:8px;background:${index===0?'var(--blueL)':'var(--bg3)'}">
                  <div style="font-size:9px;font-weight:700;color:${index===0?'var(--accent)':'var(--text4)'};text-transform:uppercase">${index===0?'Next load':'Load '+(index+1)}</div>
                  <div style="font-size:14px;font-weight:700;margin:3px 0">${group.items.map(i=>(i.strength||'?')+' mg').join(' + ')}</div>
                  <div style="font-size:11px;color:var(--text3)">${group.items.length>1?'Combined = ':''}${group.totalMg} mg total</div>
                  ${group.pen?`<div style="font-size:10px;color:var(--purpleT);margin-top:3px">🖊️ ${esc(group.pen.labelName||group.pen.model||group.pen.brand||'Pen')}</div>`:''}
                </div>`).join('')}
              ${plan.groups.length>6?`<div style="align-self:center;color:var(--text4);font-size:11px">+${plan.groups.length-6} more</div>`:''}
            </div>
          </div>`).join('')}
      </div>
    </div>` : `
    <div class="card" style="margin-bottom:14px;cursor:pointer" onclick="setTab('allocation')">
      <div class="card-header"><div class="card-title">🧪 Upcoming Vials & Pen Loads</div></div>
      <div style="padding:0 16px 14px;color:var(--text4);font-size:12px">No vial order assigned yet. Open Allocation to fill an active protocol.</div>
    </div>`}

    <!-- Planned Schedule -->
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('calendar')"><div class="card-title">📅 Planned Today${currentUser ? ' — ' + esc(currentUserName) : ''}</div></div>
      ${plannedToday.length === 0
        ? '<div style="padding:16px;color:var(--text4);font-size:13px">No planned administrations today</div>'
        : '<div style="padding:0 16px 12px">' + plannedToday.map(p => `
        <div style="padding:8px 0;border-bottom:1px solid var(--border);font-size:13px">
          <span style="font-weight:600">${esc(p.name)}</span>
          <span style="color:var(--text3)">${esc(p.dosage||'')}</span>
        </div>`).join('') + '</div>'}
    </div>

    <!-- Upcoming This Week -->
    ${plannedWeek.length > 0 ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('calendar')"><div class="card-title">📋 Planned This Week</div><span class="badge badge-blue">${plannedWeek.length}</span></div>
      <div style="padding:0 16px 12px;max-height:200px;overflow-y:auto">
        ${plannedWeek.slice(0,20).map(p => `
        <div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border);display:flex;gap:8px;align-items:center">
          <span style="font-weight:600">${esc(p.name)}</span>
          <div class="spacer"></div>
          <span style="color:var(--text4)">${esc(p.dosage||'')}</span>
          <span style="color:var(--text3);font-size:11px">${p.date.slice(5)}</span>
        </div>`).join('')}
      </div>
    </div>` : ''}

    <!-- Upcoming Plan Changes -->
    ${planChanges.length > 0 ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('cycles')"><div class="card-title">🔄 Upcoming Plan Changes</div></div>
      <div style="padding:0 16px 12px">
        ${planChanges.slice(0,10).map(pc => `
        <div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border)">
          ${pc.type === 'ending' ? `<span style="color:var(--amber)">⚠ ${esc(pc.name)} cycle ends ${pc.date}</span>` :
            `<span style="color:var(--blue)">↗ ${esc(pc.name)} dose changes ${pc.from} → ${pc.to} on ${pc.date}</span>`}
        </div>`).join('')}
      </div>
    </div>` : ''}

    <!-- Inventory Readiness -->
    ${readiness.filter(r => r.shortfall > 0).length > 0 ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('peptides')"><div class="card-title">📦 Inventory Shortfall</div><span class="badge badge-red">${readiness.filter(r=>r.shortfall>0).length}</span></div>
      <div style="padding:0 16px 12px">
        ${readiness.filter(r => r.shortfall > 0).map(r => `
        <div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border);display:flex;gap:8px;align-items:center">
          <span style="font-weight:600;color:var(--red)">${esc(r.name)}</span>
          <div class="spacer"></div>
          <span style="color:var(--text3)">${r.onHand} on hand · ${r.needed} needed</span>
          <span class="badge badge-red" style="font-size:10px">${r.shortfall} short</span>
        </div>`).join('')}
      </div>
    </div>` : ''}

    <!-- Supplements Reference (AM/Noon/PM) -->
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:12px;margin-bottom:14px">
      <div class="card" style="cursor:pointer" onclick="setTab('supplements')">
        <div class="card-header"><div class="card-title">☀️ AM Regimen</div><span class="badge badge-gray">${amSupps.length}</span></div>
        <div style="padding:0 16px 12px;max-height:200px;overflow-y:auto">
          ${amSupps.length === 0 ? '<div style="color:var(--text4);font-size:12px;padding:8px 0">None</div>' :
            amSupps.map(s => `<div style="font-size:12px;padding:3px 0;color:var(--text2)">${esc(s.name)} <span style="color:var(--text4)">${esc(s.strength||'')}</span></div>`).join('')}
        </div>
      </div>
      <div class="card" style="cursor:pointer" onclick="setTab('supplements')">
        <div class="card-header"><div class="card-title">🕛 Noon Regimen</div><span class="badge badge-gray">${noonSupps.length}</span></div>
        <div style="padding:0 16px 12px;max-height:200px;overflow-y:auto">
          ${noonSupps.length === 0 ? '<div style="color:var(--text4);font-size:12px;padding:8px 0">None</div>' :
            noonSupps.map(s => `<div style="font-size:12px;padding:3px 0;color:var(--text2)">${esc(s.name)} <span style="color:var(--text4)">${esc(s.strength||'')}</span></div>`).join('')}
        </div>
      </div>
      <div class="card" style="cursor:pointer" onclick="setTab('supplements')">
        <div class="card-header"><div class="card-title">🌙 PM Regimen</div><span class="badge badge-gray">${pmSupps.length}</span></div>
        <div style="padding:0 16px 12px;max-height:200px;overflow-y:auto">
          ${pmSupps.length === 0 ? '<div style="color:var(--text4);font-size:12px;padding:8px 0">None</div>' :
            pmSupps.map(s => `<div style="font-size:12px;padding:3px 0;color:var(--text2)">${esc(s.name)} <span style="color:var(--text4)">${esc(s.strength||'')}</span></div>`).join('')}
        </div>
      </div>
    </div>

    <!-- Expiration Alerts -->
    ${expirationConflicts.length ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('peptides')"><div class="card-title">⏰ Expiration Alerts</div><span class="badge badge-amber">${expirationConflicts.length}</span></div>
      <div style="padding:0 16px 12px">
        ${expirationConflicts.slice(0, 15).map(e => `
        <div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border);display:flex;gap:8px;align-items:center">
          <span style="font-weight:600;color:${e.expired?'var(--red)':e.urgent?'var(--amber)':'var(--text)'}">${esc(e.name)}</span>
          <span class="badge badge-gray" style="font-size:10px">${esc(e.type)}</span>
          ${e.plannedConflict ? '<span class="badge badge-red" style="font-size:9px">expires before plan</span>' : ''}
          <div class="spacer"></div>
          <span style="color:${e.expired?'var(--red)':e.urgent?'var(--amber)':'var(--text4)'}">${e.expired?'EXPIRED':'Exp'} ${e.expiry.slice(0,10)}</span>
        </div>`).join('')}
        ${expirationConflicts.length > 15 ? `<div style="font-size:11px;color:var(--text4);padding-top:6px">+${expirationConflicts.length-15} more</div>` : ''}
      </div>
    </div>` : ''}

    <!-- Low Stock -->
    ${lowItems.length ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header" style="cursor:pointer" onclick="setTab('peptides')"><div class="card-title">📉 Low Stock</div><span class="badge badge-red">${lowItems.length}</span></div>
      <div style="padding:0 16px 12px">
        ${lowItems.map(e => `
        <div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border);display:flex;gap:8px;align-items:center">
          <span style="font-weight:600;color:var(--amber)">${esc(e.name)}</span>
          <span class="badge badge-gray" style="font-size:10px">${esc(e.type)}</span>
          <div class="spacer"></div>
          <span style="color:var(--red)">${e.qty}${e.unit?' '+e.unit:''} remaining</span>
        </div>`).join('')}
      </div>
    </div>` : ''}

    <!-- Data Quality -->
    ${activeDQ.length > 0 ? `
    <div class="card" style="margin-bottom:14px">
      <div class="card-header"><div class="card-title">🔍 Data Quality</div><span class="badge badge-gray">${activeDQ.length}</span></div>
      <div style="padding:0 16px 12px">
        ${activeDQ.slice(0,10).map(d => `
        <div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border);display:flex;gap:8px;align-items:center;cursor:pointer" onclick="setTab('${d.tab}')">
          <span style="color:var(--text3)">⚠ ${esc(d.msg)}</span>
        </div>`).join('')}
        ${activeDQ.length > 10 ? `<div style="font-size:11px;color:var(--text4);padding-top:6px">+${activeDQ.length-10} more</div>` : ''}
      </div>
    </div>` : ''}
  </div>`
}

export {
  renderPeptideLibraryTab,
  renderCategoryCardsTab,
  renderChangeLogTab,
  renderDashboardTab
}
